export default __webpack_public_path__ + "static/media/NonPayPeriodReportLogo.5e072526.svg";